module.exports = __webpack_public_path__ + "img/2019-01-18.a28d2483.jpg";